import _ from 'lodash';
import { Icon, Box, Flex } from '@vibe/core';
import { AppModal, AppModalContent, AppModalFooter } from '@gorilla/ui/src/components/AppModal';
import { Heading } from '@vibe/core';
import { Person, Email, DropdownChevronRight } from '@vibe/icons';
import { ImportAccountButton } from './ImportAccountButton';
import { type AccountImport } from '@gorilla/portal-shared/src/schemas';

type ImportAccountModalProps = {
  show: boolean;
  onClose: (accountToImport?: AccountImport) => void;
};

export function ImportAccountModal({ show, onClose }: ImportAccountModalProps) {
  return (
    <AppModal
      show={show}
      onClose={() => {
        onClose();
      }}
      width={400}
      alertDialog={false}
      data-testid="import-account-modal"
    >
      <AppModalContent>
        <Box>
          <Flex gap={12} style={{ marginBottom: '32px' }}>
            <Icon icon={Person} size={22} style={{ transform: 'translate3d(0,-1px,0)' }} />
            <Flex gap={4}>
              <Heading type="h3" weight="normal" align="start" maxLines={1} ellipsis={false}>
                Import
              </Heading>
              <Icon icon={DropdownChevronRight} size={22} style={{ transform: 'translate3d(0,0,0)' }} />
              <Heading
                type="h3"
                weight="bold"
                align="start"
                maxLines={1}
                ellipsis={true}
                withoutTooltip
                style={{
                  width: '270px',
                }}
              >
                Login method
              </Heading>
            </Flex>
          </Flex>
          <Box padding="medium" backgroundColor="allgreyBackgroundColor" rounded="small" border borderColor="layoutBorderColor">
            <ImportAccountButton
              onUploaded={async (newAccountImport) => {
                onClose(newAccountImport);
              }}
            />
          </Box>
        </Box>
      </AppModalContent>
      <AppModalFooter>
        <Flex gap={12} justify={'end' as any}>
          <Box marginEnd={'auto' as any}>
            <Flex gap={6} style={{ color: '#afb0bd' }}>
              <Icon icon={Email} size={20} />
              <div style={{ fontSize: '14px' }}>Import login method</div>
            </Flex>
          </Box>
        </Flex>
      </AppModalFooter>
    </AppModal>
  );
}
